import React, {forwardRef, useState} from 'react';
import {FooterStyle, TextStyle} from '../assets/css/Styles';
import {
  FaLinkedinIn,
  FaGithub,
  FaFacebookF,
  FaHackerrank,
  FaTwitter,
} from 'react-icons/fa';
import {Container, Col, Row} from 'react-bootstrap';

export const Footer = forwardRef(({...props}, ref) => {
  const [linkedInActive, setLinkedInActive] = useState(false);
  const [githubActive, setGithubActive] = useState(false);
  const [hackerRankActive, setHackerRankActive] = useState(false);
  const [facebookActive, setFacebookActive] = useState(false);
  const [twitterActive, setTwitterActive] = useState(false);
  return (
    <div style={FooterStyle.footerMainContainer}>
      <Container ref={ref} style={FooterStyle.footerContainer}>
        <Row style={FooterStyle.iconsRow}>
          <div
            style={linkedInActive ?
               FooterStyle.eachIconDivActive : FooterStyle.eachIconDiv}
            onMouseEnter={() => setLinkedInActive(true)}
            onMouseLeave={() => setLinkedInActive(false)}
            onClick={() => window.open('https://www.linkedin.com/in/clement-gyimah-117b20149')}>
            <FaLinkedinIn
              style={
                  linkedInActive ?
                  FooterStyle.socialIconActive :
                  FooterStyle.socialIcon}
            />
          </div>
          <div style={
              githubActive ?
               FooterStyle.eachIconDivActive : FooterStyle.eachIconDiv}
          onMouseEnter={() => setGithubActive(true)}
          onMouseLeave={() => setGithubActive(false)}
          onClick={() => window.open('https://github.com/clementgyimah')}>
            <FaGithub
              style={
                  githubActive ?
                  FooterStyle.socialIconActive :
                  FooterStyle.socialIcon}
            />
          </div>
          <div style={
              hackerRankActive ?
               FooterStyle.eachIconDivActive : FooterStyle.eachIconDiv}
          onMouseEnter={() => setHackerRankActive(true)}
          onMouseLeave={() => setHackerRankActive(false)}
          onClick={() => window.open('https://www.hackerrank.com/clementgyimah2')}>
            <FaHackerrank
              style={
                  hackerRankActive ?
                  FooterStyle.socialIconActive :
                  FooterStyle.socialIcon}
            />
          </div>
          <div style={
              facebookActive ?
               FooterStyle.eachIconDivActive : FooterStyle.eachIconDiv}
          onMouseEnter={() => setFacebookActive(true)}
          onMouseLeave={() => setFacebookActive(false)}
          onClick={() => window.open('https://web.facebook.com/profile.php?id=100005602457246')}>
            <FaFacebookF
              style={
                  facebookActive ?
                  FooterStyle.socialIconActive :
                  FooterStyle.socialIcon}
            />
          </div>
          <div style={
              twitterActive ?
               FooterStyle.eachIconDivActive : FooterStyle.eachIconDiv}
          onMouseEnter={() => setTwitterActive(true)}
          onMouseLeave={() => setTwitterActive(false)}
          onClick={() => window.open('https://twitter.com/DjClemo2')}>
            <FaTwitter
              style={
                  twitterActive ?
                  FooterStyle.socialIconActive :
                  FooterStyle.socialIcon}
            />
          </div>
        </Row>
        <Col style={FooterStyle.copyRightTxtDiv}>
          <span style={TextStyle.normalTxt1}>
            Gyimah Clement © 2021. All rights reserved.
          </span>
        </Col>
      </Container>
    </div>
  );
});
